shadow$provide[97] = function(require,module,exports) {
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useDeepCompareMemo = exports.capitalize = exports.canNodeHaveChildren = exports.isSelectionParent = exports.isRootDestroyed = void 0;
/* eslint-disable no-underscore-dangle */
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var react_1 = require("react");
/**
 * Get root node given any node in Mathbox tree
 */
var getRoot = function (selection) {
    var current = selection;
    while (current._up) {
        current = current._up;
    }
    return current;
};
var isRootDestroyed = function (selection) {
    var root = getRoot(selection);
    return root.three === undefined;
};
exports.isRootDestroyed = isRootDestroyed;
/**
 * Check that parent is actually the selection's parent.
 * The mathbox components occasionally render with a selection value whose
 * parent does not match the parent specified in MathboxContext.
 *
 * I believe this fundamentally this is happening because
 * - we store parent value in context...
 * - we update the context parent value using useEffect hooks..
 * - useEffect hooks are called children before parents.
 *
 * One wonders whether we really need to be using useEffect hooks for the
 * mathbox components, or if we can just put all the node creation/removal stuff
 * in a render function. Hooks seem nice for dependencies, but mathbox is pretty
 * smart about diffing out the actual changes.
 */
var isSelectionParent = function (selection, parent) {
    var _a;
    var selectionParentNode = (_a = selection._up) === null || _a === void 0 ? void 0 : _a[0];
    return selectionParentNode === parent[0];
};
exports.isSelectionParent = isSelectionParent;
var CAN_HAVE_CHILDREN = [
    "view",
    "cartesian",
    "cartesian4",
    "polar",
    "spherical",
    "stereographic",
    "stereographic4",
    "transform",
    "transform4",
    "vertex",
    "fragment",
    "layer",
    "mask",
    "group",
    "inherit",
    "root",
    "unit",
    "rtt",
    "clock",
    "now",
    "move",
    "present",
    "reveal",
    "slide",
];
var canNodeHaveChildren = function (type) {
    return CAN_HAVE_CHILDREN.includes(type);
};
exports.canNodeHaveChildren = canNodeHaveChildren;
var capitalize = function (s) {
    if (!s)
        return "";
    return s[0].toLocaleUpperCase() + s.slice(1);
};
exports.capitalize = capitalize;
/**
 * Returns the same reference to `value` as long as the the given values are
 * deep equal.
 *
 * This is, in general, not a great idea. See
 * https://github.com/facebook/react/issues/14476#issuecomment-471199055
 *
 * This should work OK for mathbox options because the objects in question are
 * either shallow, or are deep equal at a fairly shallow level.
 * E.g., OrbitControls may not be a shall object, but if it's not, it will at
 * least be deep equal between renders.
 *
 * But should work OK for mathbox options.
 */
var useDeepCompareMemo = function (value, initial) {
    var oldValue = (0, react_1.useRef)(initial);
    var memoOptions = (0, react_1.useMemo)(function () {
        if ((0, isEqual_1["default"])(value, oldValue.current))
            return oldValue.current;
        oldValue.current = value;
        return value;
    }, [value]);
    return memoOptions;
};
exports.useDeepCompareMemo = useDeepCompareMemo;
//# sourceMappingURL=util.js.map
};